module.exports = __webpack_public_path__ + "static/image2-60a42828e8552ffbe9b482c2d386d0ec.jpg";